<div class="background">
  <div class="form-container">
    <h1 class="h1Header">Configuración de Costos de Envío</h1>
    
    <mat-card class="mat-elevation-z4">
      <form [formGroup]="costForm" (ngSubmit)="onSubmit()" class="cost-form">
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Tarifa Base</mat-label>
            <input matInput type="number" formControlName="baseRate" required>
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="costForm.get('baseRate')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('baseRate')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Distancia Base</mat-label>
            <input matInput type="number" formControlName="baseDistanceKm" required>
            <span matSuffix>km</span>
            <mat-error *ngIf="costForm.get('baseDistanceKm')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('baseDistanceKm')?.hasError('min')">Debe ser mayor o igual a 1</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Tarifa por km extra</mat-label>
            <input matInput type="number" formControlName="extraKmRate" required>
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="costForm.get('extraKmRate')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('extraKmRate')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>% Descuento Ida y Vuelta</mat-label>
            <input matInput type="number" formControlName="roundTripReturnDiscountPercent" required>
            <span matSuffix>%</span>
            <mat-error *ngIf="costForm.get('roundTripReturnDiscountPercent')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('roundTripReturnDiscountPercent')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
            <mat-error *ngIf="costForm.get('roundTripReturnDiscountPercent')?.hasError('max')">Máximo 100%</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Tarifa de Espera (cada 10 min)</mat-label>
            <input matInput type="number" formControlName="waitFeePer10Min" required>
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="costForm.get('waitFeePer10Min')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('waitFeePer10Min')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Cargo por Sobredimensión</mat-label>
            <input matInput type="number" formControlName="oversizeItemFee" required>
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="costForm.get('oversizeItemFee')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('oversizeItemFee')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Recargo por Lluvia (base)</mat-label>
            <input matInput type="number" formControlName="rainSurchargeBase" required>
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="costForm.get('rainSurchargeBase')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('rainSurchargeBase')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Recargo por Lluvia (por km)</mat-label>
            <input matInput type="number" formControlName="rainSurchargePerKm" required>
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="costForm.get('rainSurchargePerKm')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('rainSurchargePerKm')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>% Comisión por Pago</mat-label>
            <input matInput type="number" formControlName="productPaymentFeePercent" required>
            <span matSuffix>%</span>
            <mat-error *ngIf="costForm.get('productPaymentFeePercent')?.hasError('required')">Campo requerido</mat-error>
            <mat-error *ngIf="costForm.get('productPaymentFeePercent')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
            <mat-error *ngIf="costForm.get('productPaymentFeePercent')?.hasError('max')">Máximo 100%</mat-error>
          </mat-form-field>
        </div>

        <div class="form-actions">
          <button mat-raised-button color="primary" type="submit" [disabled]="costForm.invalid || isLoading">
            <mat-spinner *ngIf="isLoading" diameter="20" class="spinner"></mat-spinner>
            <span *ngIf="!isLoading">{{ existingRule ? 'ACTUALIZAR' : 'GUARDAR' }}</span>
          </button>
        </div>
      </form>
    </mat-card>
  </div>
</div>
